module.exports = __webpack_public_path__ + "static/media/services.f8d0c722.svg";